import { render, staticRenderFns } from "./FiveStarRating.vue?vue&type=template&id=319231b5&"
import script from "./FiveStarRating.vue?vue&type=script&lang=js&"
export * from "./FiveStarRating.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports